// Effective reverse-geocoder configuration for the address column.
// Resolution: the user's own pick (My Account → Geocoder) wins; otherwise the
// organization's default (Settings → Organization → Address lookup); otherwise
// none, and the column shows the POI label or "—". Server-side geocoding is off
// fleet-wide since v1.6.2, so this is the only place addresses come from.
const PROVIDERS = new Set(['nominatim', 'google', 'locationiq', 'mapbox']);

const str = (v) => (typeof v === 'string' ? v.trim() : '');

/** @returns {{ provider: string, key: string, language: string, source: 'user'|'org'|null }} */
export function resolveGeocoderConfig(userAttrs, orgSettings) {
  const userProvider = str(userAttrs?.geocoderProvider);
  if (PROVIDERS.has(userProvider)) {
    return { provider: userProvider, key: str(userAttrs?.geocoderKey), language: str(userAttrs?.geocoderLanguage), source: 'user' };
  }
  const org = orgSettings?.geocoder;
  const orgProvider = str(org?.provider);
  if (PROVIDERS.has(orgProvider)) {
    return { provider: orgProvider, key: str(org?.key), language: str(org?.language), source: 'org' };
  }
  return { provider: '', key: '', language: '', source: null };
}
